import Api from './api'

const urlPath = "search"

export default {
    //GET
    search: (params = {}) => Api.GET(urlPath, params),

    //POST


    //PUT

}